import { render, staticRenderFns } from "./waitDistribution.vue?vue&type=template&id=6d60f772"
import script from "./waitDistribution.vue?vue&type=script&lang=js"
export * from "./waitDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports